enum ConfigurationSummaryConfirmationCardTypeEnum {
	addToCartSuccess = 'addToCartSuccess',
	addToListSuccess = 'addToListSuccess',
	saveVpcFail = 'saveVpcFail',
	addUnavailabeToCartAndListSuccess = 'addUnavailabeToCartAndListSuccess',
	addUnavailabeToCartFailAndListSuccess = 'addUnavailabeToCartFailAndListSuccess',
	addUnavailabeToCartSuccessAndListFail = 'addUnavailabeToCartSuccessAndListFail'
}

export default ConfigurationSummaryConfirmationCardTypeEnum;
